import GovernmontList from '../../components/government/GovernmentList';

export default function GovernmentManagement() {
    return (
        <GovernmontList />
    );
}